import { Options } from '../../Options'
import { ChartCartesianConstants } from './ChartCartesian.constants'

export const chartCartesianOptions = Options.asRecord(
  Options.createOption({
    key: 'min',
    inputKind: 'number',
    label: 'Minimum',
    description: 'Force the axis floor. Omit for auto.',
    category: 'Axis',
  }),
  Options.createOption({
    key: 'max',
    inputKind: 'number',
    label: 'Maximum',
    description: 'Force the axis ceiling. Omit for auto.',
    category: 'Axis',
  }),
  Options.createOption({
    key: 'tickCount',
    inputKind: 'number',
    defaultValue: ChartCartesianConstants.yAxisTickCount,
    min: 2,
    max: 20,
    step: 1,
    label: 'Tick count',
    description: 'Approximate number of ticks for nice domain rounding.',
    category: 'Axis',
  }),
)

export type ChartCartesianOptions = Options.TypeOf<typeof chartCartesianOptions>
export type ChartCartesianResolvedOptions = Options.ResolvedTypeOf<
  typeof chartCartesianOptions
>
